import * as _ from 'underscore';

import { Component, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsMapperService } from '../../../analytics/services/analytics.mapper.service';
import { DropDownSettings, LazyDropdownComponent } from '../lazy-dropdown/lazy-dropdown.component';
import { AnalyticsMixpanelService } from '../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-datasource-dropdown',
	styleUrls: ['./datasource-dropdown.component.css'],
	templateUrl: './datasource-dropdown.component.html'
})
export class DataSourceDropdownComponent extends LazyDropdownComponent implements OnInit {
	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsMapperService: AnalyticsMapperService,
		protected analyticsMixpanelService : AnalyticsMixpanelService
	) {
		super(analyticsDataModel, analyticsMapperService,analyticsMixpanelService);
	}

	ngOnInit(): void {
		this.type = 'datasources';
		this.setPropertiesByType();
		this.getConfigurationByType();
		this.refreshData();
	}

	setPropertiesByType(): void {
		this.dropdownSettings = {
			clearAllText: 'Clear All',
			clearable: false,
			closeOnSelect: false,
			loading: false,
			loadingText: 'Loading Data Sources',
			multiple: true,
			notFoundText: 'No DataSources Found',
			placeholder: 'Select Data Source',
			searchable: true,
			virtualScroll: true
		} as DropDownSettings;
	}

	getConfigurationByType(): void {
		this.dropdownList = this.analyticsDataModel.config.dataSources;
		this.selectedItems = _.where(this.dropdownList, { selected: true });
	}

	onAdd(item: any): void {
		item.selected = true;
	}

	unselectAll(): void {
		this.selectedItems = [];
		this.dropdownList = this.dropdownList.map((data) => {
			data.selected = false;
			return data;
		});
	}

	onRemove(item: any): void {
		item.value.selected = false;
	}

	refreshData(): void {
		setTimeout(() => {
			EmitterService.get(EVENT_EMITTERS.REFRESH_DATA_SOURCE).emit(this.selectedItems);
		}, 250);
	}

	onClose(): void {
		this.refreshData();
	}
}
